import PricingPlans from "./PricingPlans";
import PricingCTA from "./PricingCTA";

export default function Pricing() {
  return (
    <div id="pricing">
      <PricingPlans />
      <PricingCTA />
    </div>
  );
}